<template>
  <!-- TODO 付费订阅页数据展示判断需要更改 -->
  <div v-if="data?.idx" class="rights-card-compare">
    <div class="title flex-y-center h-[60px]">
      <div
        class="w-[320px] flex-shrink-0 flex-y-center gap-[6px] !pl-[30px] font-bold"
      >
        <img :src="iconConfig[vipIconIdx]" class="h-[20px]" />
        {{ data.title }}
        <authorization-differences
          v-if="data.idx === 3 && !isGlobalVersion()"
          v-slot="{ show }"
          class="inline-block"
        >
          <Resource
            class="w-[13px] h-[13px] cursor-pointer"
            :src="getFeUrl('/youyan-platform/png/icon-circle-white.png')"
            @click="show"
          />
        </authorization-differences>
      </div>
      <template v-for="(item, index) in colorsGroup" :key="index">
        <div v-if="index > 0" class="w-auto h-full flex-1"></div>
      </template>
    </div>
    <div v-for="(item, index) in data.items" :key="index">
      <div v-if="!item?.children" class="flex-y-center intro-row">
        <div
          class="flex-y-center flex-shrink-0 w-[220px] gap-[5px] min-h-[60px]"
        >
          <div
            class="font-bold pl-[30px] text-font-1 text-[14px]"
            v-html="item.title"
          ></div>
          <div v-if="item?.hover">
            <a-tooltip placement="right">
              <template #title>
                <div class="text-font-1" v-html="item.hover"></div>
              </template>
              <Resource
                class="w-[13px] h-[13px]"
                :src="getFeUrl('/youyan-platform/png/icon-circle-white.png')"
              />
            </a-tooltip>
          </div>
        </div>
        <CardItem v-if="!item.children" :item="item" :colorsMap="colorsMap" />
      </div>
      <template v-else>
        <div class="flex intro-flex">
          <div
            class="font-bold flex-shrink-0 w-[320px] pl-[20px] flex-y-center py-[20px] self-stretch text-font-1"
          >
            {{ item.title }}
          </div>
          <template v-for="(item, index) in colorsGroup" :key="index">
            <div v-if="index > 0" class="w-auto flex-1"></div>
          </template>
        </div>
        <div
          v-for="(detail, idx) in item.children"
          :key="idx"
          class="flex-y-center intro-row"
        >
          <div
            class="text-14 flex-shrink-0 w-[220px] pt-[12px] pb-[12px] pl-[20px] pr-[24px] flex-y-center self-stretch relative text-font-1"
          >
            <div class="relative text-[12px]">{{ detail.title }}</div>
          </div>
          <CardItem :item="detail" :colorsMap="colorsMap" />
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CardItem from './card-item.vue'
import AuthorizationDifferences from '~/features/paymentDesk/components/buy-rights/authorization-differences.vue'
import { type IRightsCompare } from '~/api/interface/rights'
import vipBlue from '~/assets/svg/vip-blue.svg?url'
import vipGold from '~/assets/svg/vip-gold.svg?url'
import vipPink from '~/assets/svg/vip-pink.svg?url'
import vipPurple from '~/assets/svg/vip-purple.svg?url'
import vipGreen from '~/assets/svg/vip-green.svg?url'

const props = defineProps<{
  data?: IRightsCompare
  colorsMap: any
  iconName: string
  vipIconIdx: number
}>()

const iconConfig = [vipPink, vipBlue, vipPurple, vipGold, vipGreen]

const colorsGroup = computed(() => {
  return Object.values(props.colorsMap)
})
</script>

<style lang="scss">
.rights-card-compare {
  &:last-child {
    border-bottom: 1px solid var(--back-5);
  }
  .title {
    @apply text-16 flex-y-center;
    color: var(--text-1);
    border-bottom: 1px solid var(--back-5);
    > div {
      padding: 16px 0;
    }
  }

  .intro-row {
    border-bottom: 1px solid var(--back-5);
    position: relative;
    &:hover {
      background-color: var(--back-2);
    }
  }
  .intro-flex {
    border-bottom: 1px solid var(--back-5);
  }
}
</style>
